/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ab_Bullet2Inputs */

const es_ab_bullet2 = /** @type {(inputs: Ab_Bullet2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reservas seguras, tu decides si la aceptas o no`)
};

const gl_ab_bullet2 = /** @type {(inputs: Ab_Bullet2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reservas seguras, ti decides se a aceptas ou non`)
};

const en_ab_bullet2 = /** @type {(inputs: Ab_Bullet2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Secure bookings — you decide whether to accept`)
};

/**
* | output |
* | --- |
* | "Secure bookings — you decide whether to accept" |
*
* @param {Ab_Bullet2Inputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const ab_bullet2 = /** @type {((inputs?: Ab_Bullet2Inputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ab_Bullet2Inputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_ab_bullet2(inputs)
	if (locale === "en") return en_ab_bullet2(inputs)
	return es_ab_bullet2(inputs)
});